import type { CrmTranslate } from './crm-copy';

export function createCrmRealEstateFormsCopy(t: CrmTranslate) {
  return {
    companyForm: {
      titles: {
        create: t('crm.companyForm.titles.create'),
        edit: t('crm.companyForm.titles.edit'),
      },
      actions: {
        cancel: t('crm.companyForm.actions.cancel'),
        creating: t('crm.companyForm.actions.creating'),
        updating: t('crm.companyForm.actions.updating'),
        create: t('crm.companyForm.actions.create'),
        update: t('crm.companyForm.actions.update'),
      },
      sections: {
        basicInformation: t('crm.companyForm.sections.basicInformation'),
        contactInformation: t('crm.companyForm.sections.contactInformation'),
      },
      labels: {
        companyNameRequired: t('crm.companyForm.labels.companyNameRequired'),
        externalId: t('crm.companyForm.labels.externalId'),
        industry: t('crm.companyForm.labels.industry'),
        primarySubIndustry: t('crm.companyForm.labels.primarySubIndustry'),
        companySize: t('crm.companyForm.labels.companySize'),
        foundedYear: t('crm.companyForm.labels.foundedYear'),
        ticker: t('crm.companyForm.labels.ticker'),
        employeeCount: t('crm.companyForm.labels.employeeCount'),
        employeeRange: t('crm.companyForm.labels.employeeRange'),
        revenueRange: t('crm.companyForm.labels.revenueRange'),
        description: t('crm.companyForm.labels.description'),
        website: t('crm.companyForm.labels.website'),
        domain: t('crm.companyForm.labels.domain'),
        email: t('crm.companyForm.labels.email'),
        phone: t('crm.companyForm.labels.phone'),
        fax: t('crm.companyForm.labels.fax'),
        linkedInUrl: t('crm.companyForm.labels.linkedInUrl'),
        externalProfileUrl: t('crm.companyForm.labels.externalProfileUrl'),
        address: t('crm.companyForm.labels.address'),
        city: t('crm.companyForm.labels.city'),
        stateRegion: t('crm.companyForm.labels.stateRegion'),
        postalCode: t('crm.companyForm.labels.postalCode'),
        country: t('crm.companyForm.labels.country'),
        logoUrl: t('crm.companyForm.labels.logoUrl'),
      },
      placeholders: {
        companyName: t('crm.companyForm.placeholders.companyName'),
        externalId: t('crm.companyForm.placeholders.externalId'),
        primarySubIndustry: t('crm.companyForm.placeholders.primarySubIndustry'),
        foundedYear: t('crm.companyForm.placeholders.foundedYear'),
        ticker: t('crm.companyForm.placeholders.ticker'),
        employeeCount: t('crm.companyForm.placeholders.employeeCount'),
        employeeRange: t('crm.companyForm.placeholders.employeeRange'),
        revenueRange: t('crm.companyForm.placeholders.revenueRange'),
        description: t('crm.companyForm.placeholders.description'),
        website: t('crm.companyForm.placeholders.website'),
        domain: t('crm.companyForm.placeholders.domain'),
        email: t('crm.companyForm.placeholders.email'),
        phone: t('crm.companyForm.placeholders.phone'),
        fax: t('crm.companyForm.placeholders.fax'),
        linkedInUrl: t('crm.companyForm.placeholders.linkedInUrl'),
        externalProfileUrl: t('crm.companyForm.placeholders.externalProfileUrl'),
        address: t('crm.companyForm.placeholders.address'),
        city: t('crm.companyForm.placeholders.city'),
        stateRegion: t('crm.companyForm.placeholders.stateRegion'),
        postalCode: t('crm.companyForm.placeholders.postalCode'),
        country: t('crm.companyForm.placeholders.country'),
        logoUrl: t('crm.companyForm.placeholders.logoUrl'),
      },
      emptyOptions: {
        industry: t('crm.companyForm.emptyOptions.industry'),
        companySize: t('crm.companyForm.emptyOptions.companySize'),
      },
      options: {
        industries: [
          t('crm.companyForm.options.industries.technology'),
          t('crm.companyForm.options.industries.healthcare'),
          t('crm.companyForm.options.industries.finance'),
          t('crm.companyForm.options.industries.education'),
          t('crm.companyForm.options.industries.retail'),
          t('crm.companyForm.options.industries.manufacturing'),
          t('crm.companyForm.options.industries.realEstate'),
          t('crm.companyForm.options.industries.consulting'),
          t('crm.companyForm.options.industries.media'),
          t('crm.companyForm.options.industries.other'),
        ],
        sizes: {
          startup: t('crm.companyForm.options.sizes.startup'),
          small: t('crm.companyForm.options.sizes.small'),
          medium: t('crm.companyForm.options.sizes.medium'),
          large: t('crm.companyForm.options.sizes.large'),
          enterprise: t('crm.companyForm.options.sizes.enterprise'),
        },
      },
      validation: {
        companyNameRequired: t('crm.companyForm.validation.companyNameRequired'),
        invalidEmail: t('crm.companyForm.validation.invalidEmail'),
        invalidUrlOrHostname: t('crm.companyForm.validation.invalidUrlOrHostname'),
        companyIdRequired: t('crm.companyForm.validation.companyIdRequired'),
      },
      messages: {
        createSuccess: t('crm.companyForm.messages.createSuccess'),
        updateSuccess: t('crm.companyForm.messages.updateSuccess'),
        createFailed: t('crm.companyForm.messages.createFailed'),
        updateFailed: t('crm.companyForm.messages.updateFailed'),
      },
    },
  };
}
